import firebase from '../../../config/firebase';

const database = firebase.database();

export function loadNotifications (callback) {
    database.ref('notifications').on('value', function(snapshot) {
          const notifies = snapshot.val();
          callback(true, notifies, null);
      })
}

/**
 * Save new notification
 */
export const saveNotification = (data, callback) => {
    console.log('Api sn', data);
    var newId = database.ref().child('notifications').push().key;
    data['id'] = newId;

    database.ref('notifications/' + newId).set(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    })
}

/**
 * Edit news
 */
export function editNotification (notificationId, data, callback) {

    database.ref('notifications/' + notificationId).update(data, function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, data, null);
        }
    });
}

/**
 * Delete news
 */
export function deleteNotification (notificationId, callback) {
    database.ref('notifications').child(notificationId).remove(function(error) {
        if (error) {
            callback(false, null, error);
        } else {
            callback(true, notificationId, null);
        }
    });
}
